// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__h03d0","dashed":"Divider_dashed__QV7ac"};